import React from 'react'
import PropTypes from 'prop-types'
import {
  Container,
  Divider,
  Dropdown,
  Grid,
  Header,
  Image,
  List,
  Menu,
  Segment,
} from 'semantic-ui-react'

import './FooterView.scss'

import EnglishFlag from '../../../assets/flags/en_US.png'
import SpanishFlag from '../../../assets/flags/es_MX.png'

import MAYA from '../../../maya_api'
import {getLanguageScope} from '../../../helpers'
const _i18n = getLanguageScope('footer');

class FooterLayout extends React.Component{
  constructor(props){
    super(props);
  }

  logout() {
    return MAYA.logout();
  };

  render(){
    const {changeLanguage} = this.props;

    return (
      <Menu fixed='bottom' inverted>
        <Container>
          <Menu.Item>
            {_i18n('change_language')}
            <Image onClick={() => changeLanguage('en_US')} size='mini' className='image-flag' src={EnglishFlag}/>
            <Image onClick={() => changeLanguage('es_MX')} size='mini' className='image-flag' src={SpanishFlag}/>
          </Menu.Item>

          <Menu.Menu position='right'>
            <Menu.Item onClick={() => this.logout()} as='a'>{_i18n('logout')}</Menu.Item>
          </Menu.Menu>

        </Container>
      </Menu>
    )
  }
}

FooterLayout.propTypes = {

};

export default FooterLayout



// WEBPACK FOOTER //
// ./src/layouts/Footer/components/FooterView.js